import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-lahir")({
  head: () => ({
    meta: [
      { title: "Kalkulator Hari Lahir - Hitung Umur dalam Hari" },
      { name: "description", content: "Berapa lama kamu hidup sampai sekarang? Hitung umur dalam tahun, bulan, hari, jam, dan menit dari tanggal lahir." },
      { property: "og:title", content: "Kalkulator Hari Lahir" },
      { property: "og:description", content: "Berapa lama kamu hidup sampai sekarang? Cek umur dalam hari." },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Hari Lahir"
      intro="Berapa lama kamu hidup sampai sekarang? Masukkan tanggal lahir untuk tahu umur kamu dalam tahun, bulan, hari, jam, sampai menit."
      dateLabel="Tanggal lahir"
      verb="hidup"
      iconKey="since-cake"
      storageKey="lahir"
      path="/tools/hari-lahir"
      body={[
        { heading: "Apa itu kalkulator hari lahir?", text: "Kalkulator ini menghitung umur kamu secara presisi - bukan hanya tahun, tapi juga total hari, jam, dan menit yang sudah kamu jalani sejak lahir. Sering juga disebut 'Day Since Trend' atau Day Counter." },
        { heading: "Cara menggunakannya", text: "Cukup pilih tanggal lahirmu. Kami otomatis hitung sampai hari ini, tampilkan weton hari kamu lahir menurut kalender Jawa, dan pecah ke berbagai satuan waktu." },
        { heading: "Untuk apa sih?", text: "Cocok untuk merayakan ulang tahun, hitung berapa hari menuju ulang tahun berikutnya, atau sekadar refleksi - sudah seberapa banyak hari yang kita habiskan." },
      ]}
      faq={[
        { q: "Bagaimana cara menghitung umur dari tanggal lahir?", a: "Selisih hari antara tanggal lahir dan hari ini. Kami pecah otomatis ke tahun, bulan, hari." },
        { q: "Apakah weton tanggal lahir ditampilkan?", a: "Ya. Kami tampilkan weton hari kelahiranmu - hari + pasaran Jawa." },
        { q: "Berapa hari dalam 1 tahun?", a: "Rata-rata 365.25 hari (akibat tahun kabisat tiap 4 tahun). Kalkulator ini tetap menghitung tepat per tanggal kalender, bukan rata-rata." },
        { q: "Bisakah dipakai untuk balita?", a: "Bisa. Hasil dalam hari sangat berguna saat merayakan 100 hari atau 1000 hari kelahiran bayi." },
        { q: "Apa beda dengan tab Umur di Kalkulator Hari?", a: "Sama secara matematis. Halaman ini lebih fokus dan menyimpan tanggal lahir kamu untuk dipakai kembali." },
      ]}
    />
  ),
});